import { useMutation } from '@tanstack/react-query';
import { fetchEdgeFunction } from '@/services/supabaseClient';
import { useTenant } from '@/hooks/useTenant';

export type BagShippingService = {
  id: string | number;
  company: string | null;
  name: string;
  price: number;
  delivery_range: { min: number; max: number } | null;
};

export const useBagShippingQuote = (bagId: string) => {
  const { tenant } = useTenant();

  return useMutation({
    mutationFn: async (): Promise<BagShippingService[]> => {
      if (!tenant?.id) throw new Error('Tenant não disponível');
      if (!bagId) throw new Error('bagId obrigatório');

      const result = await fetchEdgeFunction('bag-shipping/quote', {
        method: 'POST',
        body: JSON.stringify({ tenant_id: tenant.id, bag_id: bagId }),
      });

      const services = (result?.services ?? []) as BagShippingService[];
      return services;
    },
  });
};
